import { Head } from "@inertiajs/react"

import { EnergySection } from "./_components/energy-section"
import { InventorySection } from "./_components/inventory-section"
import { Masthead } from "./_components/masthead"
import { PaletteSection } from "./_components/palette-section"
import { PatternsSection } from "./_components/patterns-section"
import { RulesSection } from "./_components/rules-section"
import { SpreadSection } from "./_components/spread-section"
import { SurfacesSection } from "./_components/surfaces-section"
import { TypeCandidates } from "./_components/type-candidates"
import { TypeSection } from "./_components/type-section"

const NAV_ITEMS = [
  { href: "#palette", label: "Palette" },
  { href: "#type", label: "Type" },
  { href: "#surfaces", label: "Surfaces" },
  { href: "#components", label: "Components" },
  { href: "#patterns", label: "Patterns" },
  { href: "#energy", label: "Energy" },
  { href: "#rules", label: "House Rules" },
]

// The Lists Desk: dev-only house style manual (/design).
// The page sits on the Oat product base (not cream; "cream is a canvas,
// not a coat") inside the .app-canvas atmosphere; cream returns only on
// bounded editorial insets. Compare with /uui-demos for the stock kit.
export default function DesignManualShow() {
  return (
    <div className="app-canvas bg-surface-base min-h-screen">
      <Head title="The Lists Desk" />

      <svg
        width="0"
        height="0"
        style={{ position: "absolute" }}
        aria-hidden="true"
      >
        <filter id="canvas-grain">
          <feTurbulence
            type="fractalNoise"
            baseFrequency="0.65"
            numOctaves={3}
            stitchTiles="stitch"
          />
        </filter>
      </svg>

      <a
        href="#top"
        className="bg-primary text-primary outline-focus-ring sr-only z-40 rounded-lg px-4 py-2 text-sm font-semibold focus-visible:not-sr-only focus-visible:absolute focus-visible:top-2 focus-visible:left-2 focus-visible:outline-2"
      >
        Skip to content
      </a>

      <nav
        aria-label="Manual sections"
        className="border-secondary bg-surface-base/90 sticky top-0 z-30 border-b backdrop-blur-sm"
      >
        <div className="max-w-container mx-auto flex items-center justify-between gap-6 px-4 py-3 lg:px-8">
          <a
            href="#top"
            className="text-primary outline-focus-ring rounded-xs text-sm font-semibold whitespace-nowrap focus-visible:outline-2 focus-visible:outline-offset-2"
          >
            The Lists Desk
          </a>
          <div className="scrollbar-hide flex items-center gap-5 overflow-x-auto">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-tertiary hover:text-primary outline-focus-ring rounded-xs text-sm font-medium whitespace-nowrap transition-colors focus-visible:outline-2 focus-visible:outline-offset-2"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      </nav>

      <main id="top">
        <Masthead />
        <PaletteSection />
        <TypeSection />
        <TypeCandidates />
        <SurfacesSection />
        <InventorySection />
        <PatternsSection />
        <EnergySection />
        <SpreadSection />
        <RulesSection />
      </main>

      <div className="end-mark py-2 pb-10" aria-hidden="true" />

      <footer className="border-secondary border-t py-10">
        <div className="max-w-container mx-auto flex flex-col gap-1 px-4 lg:px-8">
          <p className="text-tertiary text-sm">
            The Lists Desk · dev-only at /design · stock kit reference at
            /uui-demos
          </p>
          <p className="text-quaternary text-sm">
            Benchmark for finished work: the public briefs pages and the auth
            screens. Same kit, more care.
          </p>
        </div>
      </footer>
    </div>
  )
}
